import { render } from "./StatusCard.vue?vue&type=template&id=6d2f007e&scoped=true"
import script from "./StatusCard.vue?vue&type=script&lang=ts"
export * from "./StatusCard.vue?vue&type=script&lang=ts"

import "./StatusCard.vue?vue&type=style&index=0&id=6d2f007e&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-6d2f007e"

export default script